import { compose } from 'redux';
import { connect } from '../../../../react-redux';
import makeScrollable from '../../../shared/functionality/makeScrollable';
import { SessionItemResult as SessionItemResultPresenter } from './presenter';
import { featureOn } from '../../../../util/featureCheck';
function mapStateToProps(state) {
  return {
    itemResultsModifications: state.getIn(['modifications', 'sessionItemResults']),
    shouldRenderAnswerFeedback: featureOn('answer_level_feedback')
  };
}
export var SessionItemResult = compose(connect(mapStateToProps), makeScrollable)(SessionItemResultPresenter);
export default SessionItemResult;